import React from 'react'
import styled from 'styled-components'
import RewardButton from '../dropOffLocationDetails/RewardButton'
import GpsButton from '../dropOffLocationDetails/GpsButton'
import { useDropOffLocationContext } from '../../core/application/contexts'

export interface IDropOffLocationItemProps {
  onClick: () => void
  id: string
  name: string
  types: string[],
  picture?: string
  address?: {
    line: string
    zipCode: string
    countryCode: string
    city: string
  }
  coordinate: {
    latitude: number
    longitude: number
  }
}

const DropOffLocationItem: React.FC<IDropOffLocationItemProps> = ({ picture, name, id, address, coordinate, onClick, types }) => {

  const { setDisplayGetRewardDropoffId } = useDropOffLocationContext()
  const hasReward = types.includes('reward')

  let cityText = ''
  if (address?.zipCode) {
    cityText += address.zipCode
    cityText += ' '
  }
  if (address?.city) {
    cityText += address.city
  }

  return (
    <Container data-testid='dropOffLocationItem-container'>
      <InfoSection>
        {picture && <PictureWrapper data-testid='picture-wrapper' image={picture} onClick={onClick} />}
        <InfoWrapper data-testid='info-wrapper' onClick={onClick}>
          <div className='name' data-testid='name'>
            {name}
          </div>
          {address && <div className='address' data-testid='address'>
            <div>{address.line}</div>
            <div>
              <span>{cityText}</span>
            </div>
          </div>}
        </InfoWrapper>
      </InfoSection>
      <BottomSection>
        {hasReward && <RewardButton onClick={() => setDisplayGetRewardDropoffId(id)}/>}
        <GpsButton coordinate={coordinate} />
      </BottomSection>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 290px;
  row-gap: 16px;
  justify-content: space-between;
  border: 1px solid #D0D0D0;
  padding: 8px;
  border-radius: 4px;
`

const InfoSection = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
`

interface IPictureWrapperProps {
  image: string
}

const PictureWrapper = styled.div<IPictureWrapperProps>`
  display: flex;
  flex-direction: column;
  height: 64px;
  min-height: 64px;
  width: 96px;
  min-width: 96px;
  background-image: ${({ image }) => `url(${image})`};
  background-size: cover;
  border-radius: 4px;
  cursor: pointer;
`

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;

  .name {
    font-family: ${({ theme }) => theme.font.semi};
    font-size: ${({ theme }) => theme.size.small};
  }

  .address {
    font-size: ${({ theme }) => theme.size.smaller};
    display: flex;
    flex-direction: column;
  }
`

const BottomSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  column-gap: 8px;
`

export default DropOffLocationItem
